import React, { FC } from "react";

import IconProps from "./IconProps";

const CloseIcon: FC<IconProps> = ({ className }) => (
  <svg
    className={className}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_17595_3113)">
      <path
        d="M14.2929 4.29289C14.6834 3.90237 15.3164 3.90237 15.707 4.29289C16.0974 4.68342 16.0975 5.31646 15.707 5.70696L11.414 9.99992L15.707 14.2929L15.7753 14.3691C16.0956 14.7618 16.073 15.3409 15.707 15.707C15.3409 16.073 14.7618 16.0956 14.3691 15.7753L14.2929 15.707L9.99992 11.414L5.70696 15.707C5.31646 16.0975 4.68342 16.0974 4.29289 15.707C3.90237 15.3164 3.90237 14.6834 4.29289 14.2929L8.58586 9.99992L4.29289 5.70696L4.22453 5.63078C3.90418 5.23801 3.92678 4.65901 4.29289 4.29289C4.65901 3.92678 5.23801 3.90418 5.63078 4.22453L5.70696 4.29289L9.99992 8.58586L14.2929 4.29289Z"
        fill="#627293"
      />
    </g>
    <defs>
      <clipPath id="clip0_17595_3113">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default CloseIcon;
